"use strict";
/**
 * mall-account-svc
 * 商城会员
 *
 * OpenAPI spec version: last
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = void 0;
var ajax_1 = __importDefault(require("../ajax"));
var DefaultApi = /** @class */ (function () {
    function DefaultApi(basePath) {
        var _this = this;
        this.$basePath = '/mall/account'.replace(/\/$/, '');
        /**
         *
         * @summary 检测公众号
         
         * @param data: ParamsBodyv1MallConfigCheckAppPost
         * @param opt ajax config
         * @returns models.V1MallConfigCheckApp
         */
        this.v1MallConfigCheckAppPost = function (data, opt) {
            var path = '/v1/mall_config/check_app';
            var url = _this.$basePath + path;
            var p = {};
            p.data = data;
            return ajax_1.default.ajax(__assign(__assign(__assign({}, opt), { method: 'POST', url: url }), p));
        };
        if (basePath !== undefined) {
            this.$basePath = basePath.replace(/\/$/, '');
        }
    }
    return DefaultApi;
}());
exports.DefaultApi = DefaultApi;
exports.default = new DefaultApi();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGVmYXVsdEFwaS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9hcGkvRGVmYXVsdEFwaS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7Ozs7Ozs7Ozs7R0FVRzs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFFSCxpREFBaUQ7QUFrQmpEO0lBR0Usb0JBQW1CLFFBQWlCO1FBQXBDLGlCQUlDO1FBTlMsY0FBUyxHQUFHLGVBQWUsQ0FBQyxPQUFPLENBQUMsS0FBSyxFQUFFLEVBQUUsQ0FBQyxDQUFDO1FBUXpEOzs7Ozs7O1dBT0c7UUFDSyw2QkFBd0IsR0FBRyxVQUVqQyxJQUF3QyxFQUFDLEdBQXNCO1lBRS9ELElBQU0sSUFBSSxHQUFHLDJCQUEyQixDQUFDO1lBQ3pDLElBQU0sR0FBRyxHQUFHLEtBQUksQ0FBQyxTQUFTLEdBQUcsSUFBSSxDQUFDO1lBQ2xDLElBQU0sQ0FBQyxHQUFRLEVBQUUsQ0FBQztZQUNsQixDQUFDLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQztZQUNkLE9BQU8sY0FBSSxDQUFDLElBQUksZ0NBQ1gsR0FBRyxLQUNOLE1BQU0sRUFBRSxNQUFNLEVBQ2QsR0FBRyxLQUFBLEtBQ0EsQ0FBQyxFQUNKLENBQUM7UUFDTCxDQUFDLENBQUE7UUEzQkMsSUFBSSxRQUFRLEtBQUssU0FBUyxFQUFFO1lBQzFCLElBQUksQ0FBQyxTQUFTLEdBQUcsUUFBUSxDQUFDLE9BQU8sQ0FBQyxLQUFLLEVBQUUsRUFBRSxDQUFDLENBQUM7U0FDOUM7SUFDSCxDQUFDO0lBeUJILGlCQUFDO0FBQUQsQ0FBQyxBQWhDRCxJQWdDQztBQWhDWSxnQ0FBVTtBQWtDdkIsa0JBQWUsSUFBSSxVQUFVLEVBQUUsQ0FBQyJ9